/* Home.js */
/* @author: anghello */

import React from 'react';
// import { useCallback } from 'react';
// import axios from 'axios';

// const apiKey = 'LMN1AN2VIC7YnhabZoai7UAJkqnahiGj';
// const isProduction = false;

export default function Home() {

  // const submitPrompt = useCallback(async () => {
  //   try {
  //     const response = await axios.get(`https://iwbsdc6v2f.execute-api.us-east-1.amazonaws.com/dev/chat?message=${question}&key=${apiKey}&temperature=${temperature}&frequency_penalty=${frequency_penalty}&max_tokens=${max_tokens}&top_p=${top_p}&presence_penalty=${presence_penalty}&best_of=${best_of}`);
  //     const { ai } = response.data;
  //     if (ai) {
  //       // setMessage(ai);
  //     }
  //   } catch (error) {
  //     alert('ocorreu um erro');
  //     console.error(error);
  //   }
  // }, []);

  return (
    <div className='bg-black h-screen w-screen text-white'>
      LUMINOR
    </div>
  );
}
